import { disableQueryParamUpdates } from "src/lib/hooks/ClientHooks";
import { replaceSearch } from "src/lib/Navigation";

export const isDeepEqual = (a: any, b: any) => {
  if (a === b) {
    return true;
  }
  return JSON.stringify(a) === JSON.stringify(b);
};

export const toTitleCase = <S extends string | undefined | null>(string: S): S => {
  if (!string) {
    return string;
  }
  // @ts-expect-error
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const queryParentSelector = (element: HTMLElement, selector: string | string[]) => {
  let targetElement: HTMLElement | null = element;

  while (targetElement) {
    if (!targetElement) {
      return false;
    }

    if (Array.isArray(selector)) {
      if (selector.some((s) => targetElement?.matches(s))) {
        return true;
      }
    } else if (targetElement?.matches(selector)) {
      return true;
    }

    targetElement = targetElement?.parentElement;
  }

  return false;
};

interface SetQueryParamOptions {
  disableQueryParamUpdates?: boolean;
  hardNavigation?: boolean;
}

export const setQueryParam = (
  key: string,
  value: string | null | undefined,
  options?: SetQueryParamOptions,
) => {
  if (typeof window === "undefined") {
    return;
  }
  const search = new URLSearchParams(window.location.search);
  if (value === null || value === undefined) {
    search.delete(key);
  } else {
    search.set(key, value);
  }

  if (search.toString() === window.location.search.replace(/^\?/, "")) {
    return;
  }

  if (options?.hardNavigation) {
    //console.log("Hard navigation to", `${window.location.pathname}?${search}`);
    window.location.href = `${window.location.pathname}?${search}`;
    return;
  }

  replaceSearch(search.toString());

  if (options?.disableQueryParamUpdates) {
    disableQueryParamUpdates();
  }
};
